import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import StatusChip from "../common/StatusChip";

const LocationsDataGrid = ({ rows, loading, onEdit, onDeactivate }) => {
  const columns = [
    {
      field: "medicalCenter",
      headerName: "Name",
      flex: 1.2,
      minWidth: 160,
    },
    {
      field: "centerKey",
      headerName: "Key",
      width: 140,
      renderCell: ({ value }) => (
        <Typography variant="caption" fontFamily="monospace">
          {value}
        </Typography>
      ),
    },
    {
      field: "addressOffice",
      headerName: "Address",
      flex: 1.5,
      minWidth: 200,
      renderCell: ({ value }) => (
        <Typography variant="body2" noWrap title={value}>
          {value || "—"}
        </Typography>
      ),
    },
    {
      field: "managerName",
      headerName: "Manager",
      flex: 0.8,
      minWidth: 120,
      renderCell: ({ value }) => value || "—",
    },
    {
      field: "clinical",
      headerName: "Clinical",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: ({ value }) =>
        value ? (
          <CheckCircleOutlineIcon fontSize="small" color="success" />
        ) : (
          <CancelOutlinedIcon fontSize="small" color="disabled" />
        ),
    },
    {
      field: "activeEmployees",
      headerName: "Employees",
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: ({ value }) => <StatusChip active={value === 1} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <Box>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => onEdit(row)}>
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {row.status === 1 && (
            <Tooltip title="Deactivate">
              <IconButton
                size="small"
                color="error"
                onClick={() => onDeactivate(row)}
              >
                <BlockOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.locationId}
      loading={loading}
      autoHeight
      pageSizeOptions={[25, 50, 100]}
      initialState={{
        pagination: { paginationModel: { pageSize: 100 } },
        sorting: { sortModel: [{ field: "medicalCenter", sort: "asc" }] },
      }}
      disableRowSelectionOnClick
      density="comfortable"
      sx={{ border: "none" }}
    />
  );
};

export default LocationsDataGrid;
